<template>
  <div class="o-card u-padding-xsmall" id="changed-logs">
    <LockedView v-if="lockedPage">
      {{ $t("batteryDetail.changedLogsLocked") }}
    </LockedView>
    <loading v-else-if="getChangedLogsLoadingById"></loading>
    <div v-else>
      <Table
        i18n
        no-search
        :loading="getChangedLogsLoadingById"
        no-card
        checkable
        :checkValue="checkedList"
        @change:checkedList="checkedList = $event"
        :headers="headers"
        :items="changedLogs"
      >
        <template #new-button>
          <div class="u-display-flex u-width-100% u-justify-content-flex-end">
            <ExcelExport
              :fileName="`${battery.name}-export-${$date.format(new Date())}`"
              :fields="exportFields"
              :data="checkedList.length > 0 ? checkedList : changedLogs"
            >
              <template #button="{ showExcell }">
                <Button
                  @click="showExcell()"
                  variant="light-success"
                  class="u-margin-right-xsmall"
                >
                  <i class="icofont-arrow-up"></i> {{ $t("common.export") }}
                </Button>
              </template>
            </ExcelExport>
          </div>
        </template>
        <template #name="{ item }">
          <div>{{ item.name }}</div>
          <div>{{ item.type }} - {{ $date.format(item.createdAt) }}</div>
        </template>
        <template #userInfo="{ item }">
          <div>
            {{ item.userInfo.fullname }}
          </div>
        </template>
        <template #action="{ item }">
          <div>
            <div class="u-margin-bottom-xsmall">
              <chip
                class="u-margin-0"
                :variant="item.isActive ? 'success' : 'danger'"
              >
                {{
                  item.isActive ? $tc("common.active") : $tc("common.passive")
                }}
              </chip>
            </div>
            <router-link
              :to="{ name: 'batteries-detail', params: { id: item.id } }"
            >
              <Button
                size="xs"
                variant="info"
                :disabled="item.id === battery.id"
              >
                <i class="icofont-eye"></i>
                {{
                  item.id === battery.id
                    ? $t("common.alreadyView")
                    : $t("common.view")
                }}
              </Button>
            </router-link>
          </div>
        </template>
      </Table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Table from "../Base/Table/index.vue";
import Button from "../Base/Button.vue";
import Chip from "../Base/Chip.vue";
import batteryExportFields from "@/components/Batteries/batteryExportFields";
import ExcelExport from "../Base/ExcelExport.vue";
import LockedView from "../LockedView/index.vue";

export default {
  name: "ChangedLogs",
  mixins: [batteryExportFields],
  components: {
    Table,
    Chip,
    Button,
    ExcelExport,
    LockedView,
  },
  data() {
    return {
      checkedList: [],
      headers: [
        {
          col: 12,
          sm: 6,
          md: 6,
          lg: 6,
          title: "batteries.name",
          value: "name",
        },
        {
          col: 6,
          sm: 3,
          md: 3,
          lg: 3,
          title: "common.userInfo",
          value: "userInfo",
        },
        {
          col: 6,
          sm: 2,
          md: 2,
          lg: 2,
          title: "common.action",
          value: "action",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["getChangedLogsById", "getChangedLogsLoadingById"]),
    changedLogs() {
      return this.getChangedLogsById(this.battery.id).items;
    },
    exportFields() {
      return this.getExcelFields();
    },
    lockedPage() {
      return !this.battery.id || !this.battery.isPermission;
    },
  },
  props: {
    battery: {
      required: true,
      type: Object,
    },
  },
  methods: {
    async getChangedLogs() {
      if (this.battery?.id)
        if (this.battery.isPermission)
          await this.$store.dispatch("getBatteryChangedLogsById", {
            batteryId: this.battery.id,
          });
    },
  },
  mounted() {
    this.getChangedLogs();
  },
};
</script>

<style></style>
